import React, { useState } from 'react';
import { useAccounts } from '@jupiterone/jupiter-web-toolkit';
import { LogoContext } from './LogoContext';

export interface LogoContextProviderProps {
  children: React.ReactNode;
}

export const LogoContextProvider = ({ children }: LogoContextProviderProps) => {
  const { account } = useAccounts();
  const logoFromSession = account?.logo;
  const [logoURI, setLogoURI] = useState(logoFromSession || null);
  const handleSetLogoURI = (uri: string | null) => {
    if (uri === '') {
      setLogoURI(null);
    } else {
      setLogoURI(uri);
    }
  };

  const contextHandling = {
    logoURI,
    handleSetLogoURI,
  };
  return (
    <LogoContext.Provider value={contextHandling}>
      {children}
    </LogoContext.Provider>
  );
};
